import React from 'react';
import { Table, Empty, Button, Input, Form, Select } from 'antd';
const { Option } = Select;


export default function DetalleChoferModal(props) {

    return (
        <div>
            <Table
                style={{ overflowX: 'auto' }}
                className={'table-vehiculo'}
                size="small"
                pagination={false}
                dataSource={props.dataSource}
                rowKey={record => record.identifier}
                locale={{
                    emptyText: <Empty
                        image={Empty.PRESENTED_IMAGE_SIMPLE}
                        description='Pulse el bot+on "+ Agregar".'
                    />
                }}
                columns={[
                    {
                        key: 'remove-button',
                        align: 'center',
                        width: '50px',
                        render: (value, row) => (
                            <span>
                                <div className="custom-options">
                                    <Button
                                        type="danger"
                                        icon="delete"
                                        size={"small"}
                                        onClick={() => props.onRemove(row)}
                                    />
                                </div>
                            </span>
                        )
                    },
                    {
                        title: 'Nombre',
                        dataIndex: 'idChofer',
                        key: 'idChofer',
                        width: 50,
                        render: (value, row) => {
                            return (
                                <Form.Item>
                                    {props.onGetFieldDecorator(`arrnombreChofer[${row.identifier}]`, {
                                        initialValue: value ? { key: value } : undefined,
                                        rules: [{
                                            required: true,
                                            message: 'Requerido'
                                        }]
                                    })(
                                        <Select showSearch labelInValue
                                            placeholder={"Seleccione Chofer"}
                                            optionFilterProp="children"
                                            onChange={(value, option) => {

                                                props.onChangeChofer(value.key, option, row.identifier);
                                            }}
                                        >
                                            {props.choferes.map(item => (
                                                <Option key={item.id} value={item.id} licencia={item.licencia} nombres={item.razonSocial}>
                                                    {item.numeroDocumento}-{item.razonSocial}
                                                </Option>))}
                                        </Select>
                                    )}
                                </Form.Item>
                            );
                        }
                    },
                    {
                        title: 'Licencia',
                        dataIndex: 'licencia',
                        key: 'licencia',
                        width: 100,
                        render: (value, row) => {
                            return (
                                <Form.Item>
                                    {props.onGetFieldDecorator(`arrLicencia[${row.identifier}]`, {
                                        initialValue: value,
                                        validateTrigger: ['onBlur'],
                                        rules: [{
                                            required: true,
                                            message: 'Requerido',
                                            whitespace: true
                                        }]
                                    })(
                                        <Input
                                            placeholder="Ingresar Licencia"
                                            autoComplete="off"
                                            readOnly={true}
                                        />
                                    )}
                                </Form.Item>
                            );
                        }
                    },

                ]}
            />
        </div>
    );
}